import { TextField, TextFieldProps } from '@mui/material';
import React, { useState, useEffect } from 'react';

type Props = Omit<TextFieldProps, 'onChange' | 'value'> & {
  value?: string | number;
  onChangeValue?: (value: string) => void;
};

const CustomNumberTextFieldComponent: React.FC<Props> = ({
  value = '0',
  onChangeValue,
  ...rest
}) => {
  const [internalValue, setInternalValue] = useState(String(value));

  useEffect(() => {
    setInternalValue(String(value));
  }, [value]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (['-', 'e', 'E', '+'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const sanitize = (raw: string) => {
    let v = raw.replace(/[^0-9.]/g, '');

    const parts = v.split('.');
    if (parts.length > 2) {
      v = `${parts[0]}.${parts[1]}`;
    }

    if (v.startsWith('0') && !v.startsWith('0.') && v.length > 1) {
      v = v.replace(/^0+/, '');
    }

    if (v === '') v = '0';

    return v;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const clean = sanitize(e.target.value);
    setInternalValue(clean);
    onChangeValue?.(clean);
  };

  return (
    <TextField
      {...rest}
      value={internalValue}
      type="number"
      size="small"
      inputProps={{
        min: 0,
        step: 'any',
        inputMode: 'decimal',
      }}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      autoComplete="off"
    />
  );
};

export default CustomNumberTextFieldComponent;